import { Injectable } from '@angular/core';
import {UsuarioModel} from "../../models/usuario.model";
import {jwtDecode, JwtPayload} from 'jwt-decode';
import {KeycloakService} from "keycloak-angular";

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private usuario: UsuarioModel;
  private readonly key: string = "usuario";
  private permisos: string[] = [];

  constructor(private keycloak: KeycloakService) {
    if(this.keycloak.isLoggedIn())
      this.init();
  }

  async init() {
    const token = await this.keycloak.getToken();
    const decodedToken = jwtDecode(token);
    //console.log('decoded token: ', decodedToken);
    this.usuario = new UsuarioModel();
    this.initDatos(decodedToken);
  }

  initDatos(decodedToken: JwtPayload) {
    this.usuario.family_name = decodedToken['family_name'];
    this.usuario.given_name = decodedToken['given_name'];
    this.usuario.preferred_username = decodedToken['preferred_username'];
    this.usuario.name = decodedToken['name'];
    this.usuario.groups = decodedToken['groups'];
  }

  getUsuario () {
    return this.usuario;
  }

  setPermisos(permisos: string[]) {
    this.permisos = permisos || [];
  }

  getPermisos(): string[] {
    return this.permisos;
  }

  tienePermiso(codigo: string): boolean {
    return this.permisos.includes(codigo);
  }

  // Mismo orden en que aparecen las opciones en el menu de navegacion (navigation.component.html)
  private static readonly RUTAS_MENU: { ruta: string; permiso: string }[] = [
    { ruta: '/admin/gestion-jornada', permiso: 'JORNADA_VER_VISTA' },
    { ruta: '/admin/gestion-conductores', permiso: 'CONDUCTOR_VER_VISTA' },
    { ruta: '/admin/despachador', permiso: 'DESPACHADOR_VER_VISTA' },
    { ruta: '/admin/sinoptico', permiso: 'SINOPTICO_VER_VISTA' },
    { ruta: '/admin/gestion-buses', permiso: 'BUSES_VER_VISTA' },
  ];

  getPrimeraRutaPermitida(): string {
    const primera = UserService.RUTAS_MENU.find(item => this.tienePermiso(item.permiso));
    return primera ? primera.ruta : '/error-sin-permiso';
  }

  getGroups () {
    return this.usuario.groups;
  }

  getGroupsTexto () {
    if(!this.usuario.groups)
      return '';

    return this.usuario.groups.join(', ');
  }

  isUserLogged(): boolean {
    if(this.keycloak.isLoggedIn())
      return true;
    else
      return true;
  }

  tienePerfilPersonalRRHH(): boolean {
    if(this.usuario && this.usuario.groups && this.usuario.groups.find(grupoNombre => grupoNombre.toLowerCase() === ('Personal_RRHH').toLowerCase()))
      return true;
    else
      return false;
  }

  /*initUser() {
    this.usuario = JSON.parse(localStorage.getItem(this.key));
  }

  setUserToken(token: string){
    this.usuario.token = token;
  }

  getUserToken(): string {
    return this.usuario.token;
  }

  cleanSesion() {
    this.usuario = new UsuarioModel();
    this.persistUser();
  }

  persistUser() {
    localStorage.setItem(this.key, JSON.stringify(this.usuario));
  }*/
}
